import React from "react";
import ReactDOM from "react-dom";
import ContextMenuWidget from "../../widgets/ContextMenuWidget";
import FolderList from "./FolderList";
import RenameFolderEmbed from "./RenameFolderEmbed";
import { updateTree } from "@app/utilities";

export default class ModuleFolders extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rename: "none",
            currentfolder: "uncategorized",
            folders: window.apm.serialized.folders
        };
        this.initFolderChildren();
        this.pickFolder = this.pickFolder.bind(this);
        this.gethighlight = this.gethighlight.bind(this);
        this.removehighlight = this.removehighlight.bind(this);
        this.foldercontextmenu = this.foldercontextmenu.bind(this);
        this.folderdelete = this.folderdelete.bind(this);
        this.folderrename = this.folderrename.bind(this);
        this.appnavrefresh = this.appnavrefresh.bind(this);
        this.renameFolder = this.renameFolder.bind(this);
    }

    initFolderChildren(){
        const thefolders = this.state.folders;
        const folderchildren = [];
        if(typeof thefolders.modules !== "undefined") {
            for (var i = 0; i < thefolders.modules.length; i++) {
                var node = thefolders.modules[i];
                folderchildren[node.id] = [];
                if(node.children.length >= 1) {
                    for(var child in node.children) {
                        folderchildren[node.id].push(node.children[child]);
                    }
                }
            }
        }
        this.folderChildren = folderchildren;
    }

    renameFolder(id) {
        if (id) {
            const folders = window.apm.serialized.folders;
            let folderid = id;
            let foldername;
            for(var folder in folders) {
                for (var i = 0; i < folders[folder].length; i++) {
                    if(folders[folder][i].id === folderid) {
                        foldername = folders[folder][i].name;
                    }
                }
            }
            w2popup.message({
                width: 500,
                height: 220,
                html: '<div class="blank_container"></div>',
                onOpen: () => {
                    this.intervalHandler = setInterval(() => {
                        if($(".blank_container")){
                            clearInterval(this.intervalHandler);
                            
                            $(".w2ui-message").css("transform", "");

                            ReactDOM.render(
                                <RenameFolderEmbed 
                                    addFunc={this.renameDone.bind(this)} 
                                    id={id} 
                                    folder={foldername} />, 
                                    $(".blank_container").get(0));
                            }
                    }, 10);
                    
                }
            });

            return;
            
        } else {
            window.apm.popupMessage(window.l.popup.select_one_before_add);
        }
    }

    folderdelete(id) {
        const folders = window.apm.serialized.folders;
        for(var folder in folders) {
            for (var i = 0; i < folders[folder].length; i++) {
                if(folders[folder][i].id === id) {
                    folders[folder].splice([i],1);
                    window.apm.updateDeletedFoldersMap(id);
                    window.apm.serialized.folders[folder][i].props.lastLocalChange = window.apm.timestamp;
                    window.apm.setSerializedChanged();
                }

            }
        }
        if(this.state.currentfolder === id){
            this.appnavrefresh();
            this.initFolderChildren();
            this.setState({currentfolder: "uncategorized"});
        } else {
        this.appnavrefresh();
        this.initFolderChildren();
        this.setState({folders: window.apm.serialized.folders});
        }
    }

    folderrename(id) {      
        this.setState({rename: id});
    }

    renameDone(id, newvalue) {
        let nodeid = id.replace("_input", "");
        const folders = window.apm.serialized.folders;
        for(var folder in folders) {
            for (var i = 0; i < folders[folder].length; i++) {
                if(folders[folder][i].id === nodeid) {
                    folders[folder][i].name = newvalue;
                    folders[folder][i].props.lastLocalChange = window.apm.timestamp;
                    window.apm.setSerializedChanged();
                }
            }
        }
        this.appnavrefresh();
        this.initFolderChildren();
        this.setState({rename: "none"});
    }

    foldercontextmenu(event) {
        event.preventDefault();
        var contextContainer = $(".context_menu:eq(1)");
        let theid = event.target.id;
        ReactDOM.render(<ContextMenuWidget
                            folderdelete={() => this.folderdelete(theid)}
                            folderrename={() => this.renameFolder(theid)}
                            type="folderNode"
                            folderid={theid}
                            domContext={contextContainer}
                            pos={{ left: event.pageX, top: event.pageY }} />,
                        contextContainer.get(0)
                        );
      }
    
    pickFolder(e) {
        let id = e.id;
        this.setState({currentfolder: id});
    }

    gethighlight(e) {
        e.style.backgroundColor = "rgba(26, 158, 232, 0.3)";
        if(e.id === this.state.currentfolder){
            e.style.backgroundColor = "rgba(26, 158, 232, 0.6)";
        }
    }

    removehighlight(e) {
        if(e.id !== this.state.currentfolder){
            e.style.backgroundColor = "";
        }
    }

    

    dragfolder(e,currentfolder) {
        e.preventDefault();
        e.target.style.backgroundColor = "rgba(26, 158, 232, 0.3)";
        if(e.target.id === currentfolder){
        e.target.style.backgroundColor = "rgba(26, 158, 232, 0.6)";
        }
    }

    folderdrop(e,outer) {
        e.preventDefault();
        e.target.style.backgroundColor = "";
        window.apm.postEventToCurrentView({ target: "request-cancel-preview" });
        const data = e.dataTransfer.getData("text");
        const targetid = e.target.id.replace("_anchor", "");
        const moveddata = data.replace("_anchor", "");
        const components = window.apm.serialized.folders;
            for (var type in components) {
                if (type === "modules") {
                    for (var i = 0; i < components[type].length; i++) {
                        var node = components[type][i];
                        if(!node.children) {     
                            window.apm.serialized.folders[type][i].children = [];
                        }
                        if(node.id === targetid){
                            window.apm.serialized.folders[type][i].children.push(moveddata);
                            window.apm.serialized.folders[type][i].props.lastLocalChange = window.apm.timestamp;
                            window.apm.setSerializedChanged();
                        }
                        if(node.id !== targetid) {
                            for(var p = 0; p < node.children.length; p++) {
                                if(node.children[p] === moveddata) {
                                    window.apm.serialized.folders[type][i].children.splice(p,1);
                                    window.apm.serialized.folders[type][i].props.lastLocalChange = window.apm.timestamp;
                                    window.apm.setSerializedChanged();
                                }
                            }
                        } 
                    }
                }        
            }
        this.appnavrefresh();
        this.initFolderChildren();
        this.setState({folders: window.apm.serialized.folders});
    }

    appnavrefresh() {
        updateTree();
    }
    render() {    
        
        let thestyletwo = {};
            if(this.state.currentfolder === "uncategorized") {
                thestyletwo = {backgroundColor: "rgba(26, 158, 232, 0.6)"};
            }    
        return (
            <div>
                <ul role={"group"} className={"jstree-children"} style={{height: "445px", width: "345px", display: "inline-block", overflowY: "scroll"}}>
                    <li style={{marginBottom: "3px", paddingLeft: '8px'}} 
                        id={"uncategorized_anchor"} 
                        className={"jstree-node  jstree-leaf"} 
                        key={"uncategorized"}
                        >
                        <a style={thestyletwo} 
                           className={"jstree-anchor"} 
                           href={"#"} id={"uncategorized"} 
                           name={"uncategorized"}
                           onMouseOut={(e)=>this.removehighlight(e.target)} 
                           onMouseOver={(e)=>this.gethighlight(e.target)} 
                           onClick={(e)=>this.pickFolder(e.target)} 
                           onDrop={() => this.folderdrop(event,this)} 
                           onDragOver={() => this.dragfolder(event,this.state.currentfolder)}
                           >
                        <i className={"jstree-icon jstree-themeicon jstree-themeicon-custom"} role={"presentation"} style={{backgroundImage: "url('/lib/feather/folder.svg')", backgroundPosition: "center center", backgroundSize: "auto"}}></i>{"Uncategorized"}</a>
                    </li>
                    <FolderList 
                        folders={this.state.folders} 
                        context={this} 
                        list={"folders"} 
                        rename={this.state.rename} 
                        currentfolder={this.state.currentfolder} 
                        type={this.props.type} />
                </ul>
                <ul role={"group"} className={"jstree-children"} style={{height: "445px", width: "345px", display: "inline-block", overflowY: "scroll"}}>
                    <FolderList 
                        folders={this.state.folders} 
                        context={this}
                        onDrop={() => this.context.folderdrop(event, this)}
                        list={"nodes"} 
                        currentfolder={this.state.currentfolder} 
                        type={this.props.type}
                        folderChildren={this.folderChildren} />
                </ul>
            </div>
        )
    } 
}